/* Lift the Redeemly store-credit launcher clear of the bottom bars.

   Owner 2026-09-06: the launcher overlapped the Checkout button on the cart on mobile. Measured:
   button.launcher__floating-button sits at bottom:0 / z-index 990, i.e. 691-717px on a 717px
   viewport, while the sticky Checkout box occupies 650-717px. They are simply stacked.

   ⚠️ The launcher lives inside a SHADOW ROOT (#mcb-launcher-widget-root). Page stylesheets cannot
   reach into it, so a normal CSS rule — the obvious fix — silently does nothing. Two consequences:

     1. The offset is applied by injecting a <style> INTO the shadow root. The root is open, so this
        is allowed; if the app ever closes it, injection fails and we leave the widget alone.
     2. The VALUE comes from a CSS custom property set on <html>. Custom properties inherit ACROSS
        the shadow boundary, so the page keeps control of the number while the rule lives inside.

   Not solvable by putting a transform on the host to make it a containing block: the button is
   position:fixed and the host is a zero-height static div, so that would relocate the launcher
   entirely rather than nudge it.

   Bars are measured rather than hardcoded — the PDP bar auto-hides while the real Add-to-cart is in
   view, and both bars change height with the iOS safe-area inset. */
(function () {
  var BARS = '.sticky-atc-panel, .llm-cart-checkout-sticky';
  var GAP = 12;
  var injected = false;

  function inject() {
    if (injected) return true;
    var host = document.getElementById('mcb-launcher-widget-root');
    if (!host || !host.shadowRoot) return false;
    var style = document.createElement('style');
    style.setAttribute('data-llm-launcher-offset', '');
    // !important: the app sets bottom inline-ish in its own shadow stylesheet.
    style.textContent =
      '.launcher__floating-button{bottom:var(--llm-launcher-bottom,0px) !important;' +
      'transition:bottom .2s ease;}';
    host.shadowRoot.appendChild(style);
    injected = true;
    return true;
  }

  function barHeight() {
    var tallest = 0;
    var bars = document.querySelectorAll(BARS);
    for (var i = 0; i < bars.length; i++) {
      var el = bars[i];
      var s = getComputedStyle(el);
      // Only bars that are actually pinned AND actually showing.
      if (s.position !== 'fixed' || s.display === 'none' || s.visibility === 'hidden') continue;
      if (parseFloat(s.opacity) === 0) continue;
      var r = el.getBoundingClientRect();
      if (r.height < 20) continue;
      // Ignore one translated off the bottom edge (how the ATC bar hides itself).
      if (r.top >= window.innerHeight - 1) continue;
      var visible = window.innerHeight - r.top;
      if (visible > tallest) tallest = visible;
    }
    return tallest;
  }

  var last = -1;
  function apply() {
    var h = barHeight();
    var px = h > 0 ? Math.round(h + GAP) : 0;
    if (px === last) return;
    last = px;
    document.documentElement.style.setProperty('--llm-launcher-bottom', px + 'px');
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    // rAF does not fire in a background tab; the trailing timeout keeps it honest either way.
    (window.requestAnimationFrame || window.setTimeout)(function () { queued = false; apply(); });
  }

  function start() {
    apply();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
  }

  // The widget mounts late (it is an app block that fetches the customer's balance first), so poll
  // briefly for the shadow root rather than assuming it exists at DOMContentLoaded.
  var tries = 0;
  (function wait() {
    if (inject()) { start(); return; }
    if (++tries > 40) return;          // ~10s, then give up quietly
    setTimeout(wait, 250);
  })();
})();
